import { defineStore } from "pinia";
import { getCompanyId } from "@/utils/userUtils";
import repairsApi from "@/services/api/fleetRepairsApi";
import remarksApi from "@/services/api/fleetVehicleRemarksApi";

// Кандидаты для связей не меняют выборку и выбранную карточку рабочих списков
export const useRepairRemarkLinkStore = defineStore("repairRemarkLink", {
  actions: {
    async fetchRecords(resource, vehicleId, search = "") {
      if (!vehicleId) return [];
      const records = [];
      let page = 1;
      let pages = 1;
      do {
        const params = { page, limit: 100, "q[archived]": "all", "q[search]": search };
        const response = resource === "repairs"
          ? await repairsApi.index(getCompanyId(), { ...params, "q[vehicle_id]": vehicleId })
          : await remarksApi.index(getCompanyId(), vehicleId, params);
        records.push(...(response.data.result || []));
        pages = response.data.pagination_meta?.pages || 1;
        page += 1;
      } while (page <= pages);
      return records;
    },
  },
});
